module.exports = __webpack_public_path__ + "img/moon-dark.0b09f858.svg";